<app-permissions-header [projectId]="projectId" (grantPermission)="grantPermission($event)"></app-permissions-header>
<app-permissions-table
  [nodeId]="nodeId"
  [permissions]="permissions"
  (revokePermission)="revokePermission($event)"
  (changePermission)="changePermission($event)"
></app-permissions-table>
